import { render, staticRenderFns } from "./SearchArtistListItem.vue?vue&type=template&id=68a0d1c2&scoped=true&"
import script from "./SearchArtistListItem.vue?vue&type=script&lang=js&"
export * from "./SearchArtistListItem.vue?vue&type=script&lang=js&"
import style0 from "./SearchArtistListItem.vue?vue&type=style&index=0&id=68a0d1c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a0d1c2",
  null
  
)

export default component.exports